import React, { Component } from "react";
import { FiImage , FiBook , FiTarget , FiPieChart } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiImage />,
        title: 'Graphic Design',
        description: 'Packaging and editorial design, layout and production-ready assets—built to spec and aligned with real-world production constraints.'
    },
    {
        icon: <FiBook />,
        title: 'Language Services',
        description: 'Translation, copy-editing and proofreading coordinated end-to-end. Vetted linguists, consistent terminology, and clear version control—delivered per project.'
    },
    {
        icon: <FiTarget />,
        title: 'Digital Assets',
        description: 'Project-based digital deliverables: landing pages, microsites, brochures and production-ready exports—executed quickly and aligned to your brand guidelines.'
    },
    {
        icon: <FiPieChart />,
        title: 'Consulting & Project Management',
        description: 'Scoped delivery, timelines, stakeholder coordination and QA oversight for publishing and packaging workflows—so projects ship on time and to spec.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Services',
        description = 'Design, language and publishing services delivered on a project basis.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="/service"><span className="text">Services overview</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href="">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
